import { Box } from "@mui/material"
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation"
import React from "react"
import { playerStore } from "src/store/PlayerStore"

import useTranslate, { Namespaces } from "../../../../hooks/use-translate"
import { s } from "../../../../utilities/common"
import { theme } from "../../../../utilities/theme"

export const SubButton = ({ focusKey }: { focusKey?: string }) => {
  const t = useTranslate(Namespaces.Common)
  const setSubtitleSelectOpen = playerStore(
    (state) => state.setSubtitleSelectOpen,
  )
  const subtitleSelectOpen = playerStore((state) => state.subtitleSelectOpen)
  const subtitles = playerStore((state) => state.subtitles)

  const onPress = () => setSubtitleSelectOpen(!subtitleSelectOpen)

  const { focused, ref, focusSelf } = useFocusable({
    focusable: !!(subtitles && subtitles.length > 0),
    focusKey: focusKey,
    onEnterPress: onPress,
  })
  return (
    <Box
      sx={{ height: s("72px"), width: s("72px") }}
      tabIndex={0}
      aria-label={t("player__settings_subtitles")}
      onMouseEnter={() => focusSelf({ noScroll: true })}
      onMouseDown={onPress}
      ref={ref}
    >
      <svg
        width={s("72")}
        height={s("72")}
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="36"
          cy="36"
          r="36"
          fill={focused ? "white" : theme.palette.new.playerButton}
        />
        <path
          d="M29.126 50.9268C28.2324 50.9268 27.6904 50.3115 27.6904 49.3301V45.375H26.5186C22.6514 45.375 20 42.8408 20 38.6514V27.7236C20 23.5342 22.5049 21 26.7236 21H45.0049C49.2236 21 51.7285 23.5342 51.7285 27.7236V38.6514C51.7285 42.8408 49.2236 45.375 45.0049 45.375H36.1572L30.9863 49.9893C30.2393 50.6484 29.7559 50.9268 29.126 50.9268ZM27.002 34.8135H32.0557C32.6562 34.8135 33.125 34.3154 33.125 33.7295C33.125 33.1436 32.6562 32.6455 32.0557 32.6455H27.002C26.416 32.6455 25.9473 33.1582 25.9473 33.7295C25.9473 34.3154 26.4307 34.8135 27.002 34.8135ZM35.1758 34.8135H44.7266C45.3271 34.8135 45.7959 34.3154 45.7959 33.7295C45.7959 33.1436 45.3271 32.6455 44.7266 32.6455H35.1758C34.6045 32.6455 34.1357 33.1582 34.1357 33.7295C34.1357 34.3154 34.6045 34.8135 35.1758 34.8135ZM27.002 38.6807H29.2285C29.8291 38.6807 30.2979 38.1826 30.2979 37.6113C30.2979 36.9961 29.8291 36.5127 29.2285 36.5127H27.002C26.416 36.5127 25.9473 37.0107 25.9473 37.6113C25.9473 38.1826 26.4307 38.6807 27.002 38.6807ZM32.3486 38.6807H38.9111C39.4971 38.6807 39.9658 38.1826 39.9658 37.6113C39.9658 36.9961 39.4971 36.5127 38.9111 36.5127H32.3486C31.7627 36.5127 31.2939 37.0107 31.2939 37.6113C31.2939 38.1826 31.7773 38.6807 32.3486 38.6807ZM42.0166 38.6807H44.7266C45.3125 38.6807 45.7959 38.1826 45.7959 37.6113C45.7959 36.9961 45.3125 36.5127 44.7266 36.5127H42.0166C41.4307 36.5127 40.9766 37.0107 40.9766 37.6113C40.9766 38.1826 41.4453 38.6807 42.0166 38.6807Z"
          fill={focused ? theme.palette.new.playerButton : "white"}
        />
      </svg>
    </Box>
  )
}
